import { useEffect, useState } from "react";
import { useAuth } from "../../../Contexts/AuthContext";
import { useLang } from "../../../Hooks";
import { getContracts } from "../../../Services/api";

export const useIncludedServicesPage = () => {
  const [contracts, setContracts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredContracts, setFilteredContracts] = useState([]);

  const { user } = useAuth();
  const { texts } = useLang();

  useEffect(() => {
    let isActive = true;

    if (!user?.CustomerId) {
      setIsLoading(false);
      setError(texts?.includedServicesPage?.userInfoError || "");
      setContracts([]);
      setFilteredContracts([]);
      return () => {
        isActive = false;
      };
    }

    setIsLoading(true);
    setError("");

    getContracts(user.CustomerId)
      .then((response) => {
        if (!isActive) return;

        const contractsData = response.data?.data?.results || [];
        setContracts(contractsData);
        setFilteredContracts(contractsData);
      })
      .catch((err) => {
        if (!isActive) return;

        setError(err.message || texts?.includedServicesPage?.fetchError || "");
      })
      .finally(() => {
        if (isActive) {
          setIsLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [
    user?.CustomerId,
    texts?.includedServicesPage?.fetchError,
    texts?.includedServicesPage?.userInfoError
  ]);

  useEffect(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    if (!normalizedSearch) {
      setFilteredContracts(contracts);
      return;
    }

    const filtered = contracts.filter((contract) => {
      const contractName = contract.ContractTaskName?.toLowerCase() || "";
      const contractId = contract.ContractId?.toString() || "";

      return (
        contractName.includes(normalizedSearch) ||
        contractId.includes(normalizedSearch)
      );
    });

    setFilteredContracts(filtered);
  }, [contracts, searchTerm]);

  const stats = {
    totalContracts: contracts.length,
    contractsWithPackages: contracts.filter((contract) => contract.Package).length,
    activeContracts: contracts.filter((contract) => contract.Package?.IsApproved).length,
    expiredContracts: contracts.filter((contract) => {
      const endDate = contract.Package?.EndDate;
      return endDate && new Date(endDate) < new Date() && !contract.Package?.IsApproved;
    }).length
  };

  return {
    error,
    filteredContracts,
    isLoading,
    searchTerm,
    setSearchTerm,
    stats,
    texts
  };
};
